import * as React from 'react';
import OrderListItemCard from '../OrderListItemCard/OrderListItemCard.js';

const OrderListItem = ({ href , onClick , imageUrl , header , subtitle , labels  })=>{
    return /*#__PURE__*/ React.createElement(OrderListItemCard, {
        header: header,
        subtitle: subtitle,
        imagePath: imageUrl,
        href: href,
        onClick: onClick,
        labels: labels
    });
};

export { OrderListItem as default };
//# sourceMappingURL=OrderListItem.js.map
